import { Clear, Search } from '@mui/icons-material';
import { IconButton, InputAdornment, Stack, TextField } from '@mui/material';
import { type ReactNode } from 'react';

import useTranslate from 'hooks/useTranslate';

interface ListFiltersBarProps {
    search: string;
    onSearchChange: (value: string) => void;
    action?: ReactNode;
}

const ListFiltersBar = ({ search, onSearchChange, action }: ListFiltersBarProps) => {
    const { translate } = useTranslate();

    return (
        <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1.5}
            sx={{ width: '100%', alignItems: { sm: 'center' } }}
        >
            <TextField
                size="small"
                value={search}
                onChange={(event) => onSearchChange(event.target.value)}
                placeholder={translate('servicesDocuments.filters.searchPlaceholder')}
                sx={{ width: { xs: '100%', sm: '50%' }, flexGrow: 0 }}
                slotProps={{
                    input: {
                        startAdornment: (
                            <InputAdornment position="start">
                                <Search fontSize="small" />
                            </InputAdornment>
                        ),
                        endAdornment: search ? (
                            <InputAdornment position="end">
                                <IconButton
                                    size="small"
                                    aria-label={translate('clear')}
                                    onClick={() => onSearchChange('')}
                                >
                                    <Clear fontSize="small" />
                                </IconButton>
                            </InputAdornment>
                        ) : undefined,
                    },
                }}
            />

            {action}
        </Stack>
    );
};

export default ListFiltersBar;
